import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import { FormNumericTextBox, FormTextArea } from '../FormComponents'
import { RetentionPayable, PostRetentionPayable, UpdateRetentionPayable } from '../../../data/interfaces'

interface RetentionPayableFormProps {
  retentionPayable: RetentionPayable | null
  jobId: number
  onSubmit: (retentionPayable: PostRetentionPayable | UpdateRetentionPayable) => void
  onCancel: () => void
}

const RetentionPayableForm = (props: RetentionPayableFormProps) => {
  const [formData, setFormData] = useState({
    description: '',
    value: 0,
  })

  useEffect(() => {
    if (props.retentionPayable) {
      setFormData({
        description: props.retentionPayable.description,
        value: props.retentionPayable.value,
      })
    } else {
      setFormData({
        description: '',
        value: 0,
      })
    }
  }, [props.retentionPayable])

  const handleSubmit = () => {
    if (props.retentionPayable) {
      // Update existing retention payable
      const updateData: UpdateRetentionPayable = {
        retentionPayableId: props.retentionPayable.retentionPayableId,
        jobId: props.jobId,
        description: formData.description,
        value: formData.value,
      }
      props.onSubmit(updateData)
    } else {
      // Create new retention payable
      const postData: PostRetentionPayable = {
        jobId: props.jobId,
        description: formData.description,
        value: formData.value,
      }
      props.onSubmit(postData)
    }
  }

  const requiredValidator = (value: any) => {
    return value ? '' : 'This field is required'
  }

  const valueValidator = (value: number) => {
    if (!value && value !== 0) {
      return 'Value is required'
    }
    if (value > 9999999999.99) {
      return 'Value cannot exceed 9999999999.99'
    }
    return ''
  }

  return (
    <div style={{ padding: '20px' }}>
      <Form
        key={props.retentionPayable?.retentionPayableId || 'new'}
        onSubmit={handleSubmit}
        initialValues={{
          description: props.retentionPayable?.description || '',
          value: props.retentionPayable?.value || 0,
        }}
        render={(formRenderProps) => (
          <FormElement style={{ width: '100%' }}>
            <fieldset className={'k-form-fieldset'}>
              <Field
                name={'description'}
                component={FormTextArea}
                label={'Description:'}
                placeholder={'Enter retention payable description'}
                validator={requiredValidator}
                onChange={(e) => {
                  setFormData({ ...formData, description: e.value })
                }}
              />

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <p style={{ margin: '0 1em 0 0', top: '20px', position: 'relative' }}><b>£</b></p>
                <Field
                  name={'value'}
                  component={FormNumericTextBox}
                  label={'Value:'}
                  placeholder={'Enter retention payable value'}
                  validator={valueValidator}
                  format="n2"
                  min={0}
                  max={9999999999.99}
                  step={0.01}
                  onChange={(e) => {
                    setFormData({ ...formData, value: e.value })
                  }}
                />
              </div>

              <div className='button__container' style={{ marginTop: '20px' }}>
                <button
                  type="submit"
                  className='form__edit__button accept'
                  disabled={!formData.description || !formData.value}
                >
                  {props.retentionPayable ? 'Update Retention Payable' : 'Add Retention Payable'}
                </button>
                <button
                  type="button"
                  className='form__edit__button reject'
                  onClick={props.onCancel}
                >
                  Cancel
                </button>
              </div>
            </fieldset>
          </FormElement>
        )}
      />
    </div>
  )
}

export default RetentionPayableForm
